export default "__VITE_ASSET__DiK688XH__"